import apiWrapper from './helpers'

export default class IssuedCardTransaction extends apiWrapper('/issued_card_transactions') { }
